import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { canCreateSelector, isCreatingSelector } from '../selectors/userSelectors';
import { createUserRequest, updateUserRequest } from '../actions/userActions';
import { permissionsSelector } from '../../auth/selectors/authSelectors';
import UserDetailHeader from '../components/UserDetailHeader/UserDetailHeader';

const mapStateToProps = createStructuredSelector({
    permissions: permissionsSelector,
    canCreate: canCreateSelector,
    isCreating: isCreatingSelector
});

const mapDispatchToProps = {
    createUserRequest,
    updateUserRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserDetailHeader));
